import { render } from 'preact';
import { QueryClientProvider } from '@tanstack/preact-query';
import { LocationProvider, Route, Router } from 'preact-iso';
import { App } from './app.js';
import { queryClient } from './query-client.js';
import './styles.css';
import './features/editors/editor-shell.css';

const root = document.getElementById('app');
if (!root) throw new Error('Application root is missing.');
render(
  <LocationProvider scope={/^\/(?:app|auth)(?:\/|$)/u}>
    <QueryClientProvider client={queryClient}>
      <Router>
        {[<Route default component={App} />]}
      </Router>
    </QueryClientProvider>
  </LocationProvider>,
  root,
);
